<template>
  <sfs-form-modal
    :id="modalId"
    size="md"
    title="Import Recurring Charges"
    @on-hide="resetFormData"
  >
    <imports-form
      description="Create recurring charges."
      @on-submit="createRecurringChargesImport"
      @on-save="handleSave"
      @on-cancel="closeModal"
      :key="formKey"
    >
      <template #downloads>
        <b-row>
          <b-col cols="12">
            <sfs-download-button
              label="Download Template"
              filename="Recurring Charges Template.xlsx"
              :file-provider="$importsAPI.getRecurringChargesTemplate"
            />
          </b-col>
        </b-row>
      </template>
    </imports-form>
  </sfs-form-modal>
</template>

<script>
import ImportsForm from './Form.vue';
import formModalMixin from '@/mixins/formModalMixin';

export default {
  name: 'RecurringWorkOrdersImportsAddModal',
  mixins: [formModalMixin],
  components: {
    ImportsForm,
  },
  data() {
    return {
      modalId: 'recurring-charges-imports-add-modal',
    };
  },
  methods: {
    createRecurringChargesImport(data, handleCreate) {
      handleCreate(this.$importsAPI.recurringChargesCreate(data));
    },
    handleSave(data) {
      if (this.$route.name != 'imports') {
        this.$router.push({ name: 'imports' });
      } else {
        this.closeModal();
      }
      this.$emit('on-save', data);
    },
  },
};
</script>
